function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import './ButtonLabel.css';
import cs from 'classnames';
import { FormattedMessage } from 'react-intl';
/**
 * Label to nest inside a button container.
 */
export default function ButtonLabel(_ref) {
  var i18n = _ref.i18n,
    _ref$i18nKey = _ref.i18nKey,
    i18nKey = _ref$i18nKey === void 0 ? '' : _ref$i18nKey,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    className: cs('_dm-button__label', _defineProperty(_defineProperty({}, className, className), '_dm-button__label--sr-only', hideLabel))
  }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({
    id: i18nKey
  }, i18n)));
}